"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
This service contains all import field objects and import helper functions for Content Tools place/modifiers import and PCMWebUI Stops import.
*/
/* globals ALKMaps, _ */
var config = require("config");

(function () {
  "use strict";

  angular.module("alk.import").factory("alkImportService", alkImportService);

  alkImportService.$inject = ["$q", "PCMRegion", "UserProvider", "$http", "alkModalService", "$translate", "placeCloudService", "MAXDBLENGTHS", "STATES", "COUNTRIES", "$injector"];

  function alkImportService($q, PCMRegion, UserProvider, $http, alkModalService, $translate, placeCloudService, MAXDBLENGTHS, STATES, COUNTRIES, $injector) {

    var INVALID_CHAR_REGEX = /^[^\^/\\]+$/;

    //The base import field ES6 class. It holds metadata for an import field (i.e. place name, latitude).
    //All import fields will extend from this class.
    //NOTE: does not store the actual value read from CSV. This is done in importFieldsModal.controller.js.

    var BaseImportField = function () {
      function BaseImportField(params) {
        _classCallCheck(this, BaseImportField);

        this.name = params.name; //Internal name of the import field, used by the code only.
        this.translationId = params.translationId; //Translation ID of the import field that contains the translated user-facing name of the field.
        this.maxLength = params.maxLength; //The max amount of characters this field can have before the import system throws an error.
        //List of necessary import fields: throws error if this field exists, but a dependency does not.
        this.dependencies = [];
        if (params.dependencies)
          //Returns an array of ImportField objects; since they are ES6 classes, they must be instantiated first
          this.dependencies = params.dependencies.map(function (Dependency) {
            return new Dependency();
          });
      }

      //Check if the value provided as header is a suitable header for this import field type (i.e. Place Name, Latitude, etc.)


      _createClass(BaseImportField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase().includes(this.name.toLowerCase()) || headerVal.toLowerCase().includes(this.getTranslatedName());
        }

        //Get a translated name to use in messages (i.e. place name)

      }, {
        key: "getTranslatedName",
        value: function getTranslatedName() {
          return $translate.instant(this.translationId).toLowerCase();
        }

        //Get a translated name to use in messages in title case. (i.e. Place Name)

      }, {
        key: "getTranslatedNameTitleCase",
        value: function getTranslatedNameTitleCase() {
          return $translate.instant(this.translationId);
        }

        //Returns an array of strings. To be overridden by subclasses as necessary.

      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return [];
        }
      }]);

      return BaseImportField;
    }();

    /////////////////////////////////////////////////////////////////////////
    //COMMON FIELDS (SHARED BY BOTH CONTENTTOOLS PLACES AND PCMWEBUI STOPS)//
    /////////////////////////////////////////////////////////////////////////

    var LatitudeField = function (_BaseImportField) {
      _inherits(LatitudeField, _BaseImportField);

      function LatitudeField() {
        _classCallCheck(this, LatitudeField);

        return _possibleConstructorReturn(this, (LatitudeField.__proto__ || Object.getPrototypeOf(LatitudeField)).call(this, {
          name: "Latitude",
          translationId: "common.Latitude"
        }));
      }

      _createClass(LatitudeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase() === "lat" || _get(LatitudeField.prototype.__proto__ || Object.getPrototypeOf(LatitudeField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) return [];
          if (!isLatValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidLatitude") + ")"];
          }
          return [];
        }
      }]);

      return LatitudeField;
    }(BaseImportField);

    var LongitudeField = function (_BaseImportField2) {
      _inherits(LongitudeField, _BaseImportField2);

      function LongitudeField() {
        _classCallCheck(this, LongitudeField);

        return _possibleConstructorReturn(this, (LongitudeField.__proto__ || Object.getPrototypeOf(LongitudeField)).call(this, {
          name: "Longitude",
          translationId: "common.Longitude"
        }));
      }

      _createClass(LongitudeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase() === "lon" || _get(LongitudeField.prototype.__proto__ || Object.getPrototypeOf(LongitudeField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) return [];
          if (!isLonValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidLongitude") + ")"];
          }
          return [];
        }
      }]);

      return LongitudeField;
    }(BaseImportField);

    var LatLonField = function (_BaseImportField3) {
      _inherits(LatLonField, _BaseImportField3);

      function LatLonField() {
        _classCallCheck(this, LatLonField);

        return _possibleConstructorReturn(this, (LatLonField.__proto__ || Object.getPrototypeOf(LatLonField)).call(this, {
          name: "LatLon",
          translationId: "common.latLon"
        }));
      }

      _createClass(LatLonField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          var latIndex = headerVal.toLowerCase().indexOf("lat");
          var lonIndex = headerVal.toLowerCase().indexOf("lon");
          return latIndex !== -1 && lonIndex !== -1 && latIndex < lonIndex || _get(LatLonField.prototype.__proto__ || Object.getPrototypeOf(LatLonField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
          if (!fieldValue) return [];

          var _fieldValue$split = fieldValue.split(","),
              _fieldValue$split2 = _slicedToArray(_fieldValue$split, 2),
              lat = _fieldValue$split2[0],
              lon = _fieldValue$split2[1];

          if (_.isUndefined(lon)) return [fieldErr + " (" + $translate.instant("common.import.invalidLatLonNoComma") + ")"];

          if (!isLatValid(lat) || !isLonValid(lon)) return [fieldErr + " (" + $translate.instant("common.import.invalidLatLon") + ")"];

          return [];
        }
      }]);

      return LatLonField;
    }(BaseImportField);

    var StreetAddressField = function (_BaseImportField4) {
      _inherits(StreetAddressField, _BaseImportField4);

      function StreetAddressField() {
        _classCallCheck(this, StreetAddressField);

        return _possibleConstructorReturn(this, (StreetAddressField.__proto__ || Object.getPrototypeOf(StreetAddressField)).call(this, {
          name: "StreetAddress",
          translationId: "common.StreetAddress",
          maxLength: MAXDBLENGTHS.STREET
        }));
      }

      _createClass(StreetAddressField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.includes("street") || headerVal.includes("address");
        }
      }]);

      return StreetAddressField;
    }(BaseImportField);

    var CityField = function (_BaseImportField5) {
      _inherits(CityField, _BaseImportField5);

      function CityField() {
        _classCallCheck(this, CityField);

        return _possibleConstructorReturn(this, (CityField.__proto__ || Object.getPrototypeOf(CityField)).call(this, {
          name: "City",
          translationId: "common.City",
          maxLength: MAXDBLENGTHS.CITY
        }));
      }

      _createClass(CityField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return CityField;
    }(BaseImportField);

    var StateField = function (_BaseImportField6) {
      _inherits(StateField, _BaseImportField6);

      function StateField() {
        _classCallCheck(this, StateField);

        var _this6 = _possibleConstructorReturn(this, (StateField.__proto__ || Object.getPrototypeOf(StateField)).call(this, {
          name: "State",
          translationId: "common.State"
        }));

        _this6.statesList = UserProvider.getUser().region === "NA" ? STATES : [];
        return _this6;
      }

      _createClass(StateField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (this.statesList.length < 1) {
            return [];
          }
          var found = this.statesList.some(function (state) {
            return state.abbreviation.toLowerCase() === fieldValue.toLowerCase();
          });
          if (!found) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + "               (" + $translate.instant("common.import.invalidState") + ")"];
          }
          return [];
        }
      }, {
        key: "setRegion",
        value: function setRegion() {
          this.statesList = UserProvider.getUser().region === "NA" ? STATES : [];
        }
      }]);

      return StateField;
    }(BaseImportField);

    var ZipField = function (_BaseImportField7) {
      _inherits(ZipField, _BaseImportField7);

      function ZipField() {
        _classCallCheck(this, ZipField);

        return _possibleConstructorReturn(this, (ZipField.__proto__ || Object.getPrototypeOf(ZipField)).call(this, {
          name: "Zip",
          translationId: "common.Zip",
          maxLength: MAXDBLENGTHS.ZIP
        }));
      }

      return ZipField;
    }(BaseImportField);

    var CountyField = function (_BaseImportField8) {
      _inherits(CountyField, _BaseImportField8);

      function CountyField() {
        _classCallCheck(this, CountyField);

        return _possibleConstructorReturn(this, (CountyField.__proto__ || Object.getPrototypeOf(CountyField)).call(this, {
          name: "County",
          translationId: "common.County",
          maxLength: MAXDBLENGTHS.COUNTRY
        }));
      }

      return CountyField;
    }(BaseImportField);

    var CountryField = function (_BaseImportField9) {
      _inherits(CountryField, _BaseImportField9);

      function CountryField() {
        _classCallCheck(this, CountryField);

        return _possibleConstructorReturn(this, (CountryField.__proto__ || Object.getPrototypeOf(CountryField)).call(this, {
          name: "Country",
          translationId: "common.Country",
          maxLength: MAXDBLENGTHS.COUNTRY
        }));
      }

      return CountryField;
    }(BaseImportField);

    ///////////////////////////////////////
    //CONTENTTOOLS SPECIFIC PLACES FIELDS//
    ///////////////////////////////////////

    var PlaceNameField = function (_BaseImportField10) {
      _inherits(PlaceNameField, _BaseImportField10);

      function PlaceNameField() {
        _classCallCheck(this, PlaceNameField);

        return _possibleConstructorReturn(this, (PlaceNameField.__proto__ || Object.getPrototypeOf(PlaceNameField)).call(this, {
          name: "PlaceName",
          translationId: "templates.importPlaces.placeNameField",
          maxLength: MAXDBLENGTHS.PLACE_NAME
        }));
      }

      _createClass(PlaceNameField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _.includes(headerVal, "name");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return PlaceNameField;
    }(BaseImportField);

    var CompanyIdField = function (_BaseImportField11) {
      _inherits(CompanyIdField, _BaseImportField11);

      function CompanyIdField() {
        _classCallCheck(this, CompanyIdField);

        return _possibleConstructorReturn(this, (CompanyIdField.__proto__ || Object.getPrototypeOf(CompanyIdField)).call(this, {
          name: "CompanyId",
          translationId: "common.PID",
          maxLength: MAXDBLENGTHS.CID
        }));
      }

      _createClass(CompanyIdField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!/^[A-Za-z0-9]*$/.test(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidCompanyId") + "): " + fieldValue];
          }
          return [];
        }
      }]);

      return CompanyIdField;
    }(BaseImportField);

    var CountryAbbrevField = function (_BaseImportField12) {
      _inherits(CountryAbbrevField, _BaseImportField12);

      // pchen: back-compat with State (e.g., GB) export
      function CountryAbbrevField() {
        _classCallCheck(this, CountryAbbrevField);

        var _this12 = _possibleConstructorReturn(this, (CountryAbbrevField.__proto__ || Object.getPrototypeOf(CountryAbbrevField)).call(this, {
          name: "CountryAbbreviation",
          translationId: "common.CountryAbbreviation"
        }));

        _this12.countryList = COUNTRIES[UserProvider.getUser().region];
        return _this12;
      }

      _createClass(CountryAbbrevField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          var countries = this.countryList;
          var found = countries.some(function (country) {
            return country.abbreviation.toLowerCase() === fieldValue.toLowerCase();
          });
          if (!found) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + "               (" + $translate.instant("common.import.invalidState") + ")"];
          }
          return [];
        }
      }, {
        key: "setRegion",
        value: function setRegion() {
          this.countryList = COUNTRIES[UserProvider.getUser().region];
        }
      }]);

      return CountryAbbrevField;
    }(BaseImportField);

    var PhoneField = function (_BaseImportField13) {
      _inherits(PhoneField, _BaseImportField13);

      function PhoneField() {
        _classCallCheck(this, PhoneField);

        return _possibleConstructorReturn(this, (PhoneField.__proto__ || Object.getPrototypeOf(PhoneField)).call(this, {
          name: "Phone",
          translationId: "common.PhoneNumber",
          maxLength: MAXDBLENGTHS.PHONE
        }));
      }

      _createClass(PhoneField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return PhoneField;
    }(BaseImportField);

    var CommentsField = function (_BaseImportField14) {
      _inherits(CommentsField, _BaseImportField14);

      function CommentsField() {
        _classCallCheck(this, CommentsField);

        return _possibleConstructorReturn(this, (CommentsField.__proto__ || Object.getPrototypeOf(CommentsField)).call(this, {
          name: "Comments",
          translationId: "templates.importPlaces.commentField",
          maxLength: MAXDBLENGTHS.PLACE_COMMENTS
        }));
      }

      return CommentsField;
    }(BaseImportField);

    var YardNameField = function (_BaseImportField15) {
      _inherits(YardNameField, _BaseImportField15);

      function YardNameField() {
        _classCallCheck(this, YardNameField);

        return _possibleConstructorReturn(this, (YardNameField.__proto__ || Object.getPrototypeOf(YardNameField)).call(this, {
          name: "YardName",
          translationId: "templates.importPlaces.yardNameField",
          maxLength: MAXDBLENGTHS.YARD_NAME
        }));
      }

      _createClass(YardNameField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return YardNameField;
    }(BaseImportField);

    var YardPointsField = function (_BaseImportField16) {
      _inherits(YardPointsField, _BaseImportField16);

      function YardPointsField() {
        _classCallCheck(this, YardPointsField);

        return _possibleConstructorReturn(this, (YardPointsField.__proto__ || Object.getPrototypeOf(YardPointsField)).call(this, {
          name: "YardPoints",
          translationId: "templates.importPlaces.yardPointsField"
        }));
      }

      _createClass(YardPointsField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return []; //Can be blank
          }
          var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
          var errs = [fieldErr];
          var pieces = fieldValue.split("|");
          if (pieces < 3) {
            return errs; //Must have 3 points at least
          }
          // check all pieces valid
          if (!allLatLonValid(pieces)) {
            return errs;
          }

          var mapUtilities = $injector.get("mapUtilities");
          var coords = getYardPointsFromString(fieldValue).map(function (coord) {
            var mercLL = mapUtilities.LLtoMerc(coord[0], coord[1]);
            return new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat);
          });
          if (mapUtilities.isPolygonSelfIntersecting(new ALKMaps.Geometry.LinearRing(coords))) {
            var selfIntersectErr = $translate.instant("templates.importPlaces.siteSelfIntersecting");
            return [fieldErr + ": " + selfIntersectErr];
          }

          return [];
        }
      }]);

      return YardPointsField;
    }(BaseImportField);

    var GatesField = function (_BaseImportField17) {
      _inherits(GatesField, _BaseImportField17);

      function GatesField() {
        _classCallCheck(this, GatesField);

        return _possibleConstructorReturn(this, (GatesField.__proto__ || Object.getPrototypeOf(GatesField)).call(this, {
          name: "Gates",
          translationId: "templates.importPlaces.gates",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(GatesField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var enums = {
            GATE_TYPE: {
              ENTRY: "0",
              EXIT: "1",
              ENTRY_EXIT: "2"
            },
            RESTRICT: {
              FALSE: "0",
              TRUE: "1"
            }
          };

          if (!fieldValue) {
            return [];
          }
          var errors = [];

          var escPipeChar = String.fromCharCode(13);
          var escCaretChar = String.fromCharCode(14);
          var escBackslashChar = String.fromCharCode(15);

          fieldValue = getDecodedImportString(fieldValue, escPipeChar, escCaretChar, escBackslashChar);

          var gates = [];
          var gateStrs = fieldValue.split("^");

          if (gateStrs.length > 5) {
            errors.push(createGateError(fieldParams, "templates.importPlaces.tooManyGates"));
          }

          for (var i = 0; i < gateStrs.length; i++) {
            var gateStr = gateStrs[i];
            var pieces = gateStr.split("|");
            var gateNum = i + 1;

            if (pieces.length !== 6) {
              errors.push(createGateError(fieldParams, "templates.importPlaces.badGateFormat", { gateNum: gateNum }));
            } else {
              var _pieces = _slicedToArray(pieces, 6),
                  latlon = _pieces[0],
                  latlonSnap = _pieces[1],
                  gateType = _pieces[2],
                  autoRestrict = _pieces[3],
                  truckRestrict = _pieces[4],
                  note = _pieces[5];

              if (getLatLonFromString(latlon) === null) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateLatLonInvalid", { gateNum: gateNum }));
              }
              if (getLatLonFromString(latlonSnap) === null) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateLatLonSnapInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.GATE_TYPE, gateType)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateTypeInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.RESTRICT, autoRestrict)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateAutoRestrictInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.RESTRICT, truckRestrict)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateTruckRestrictInvalid", { gateNum: gateNum }));
              }
              if (autoRestrict === enums.RESTRICT.TRUE && truckRestrict === enums.RESTRICT.TRUE) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateCannotRestrictBoth", { gateNum: gateNum }));
              }
              if (note.length > MAXDBLENGTHS.YARD_GATE_NOTE) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.fieldErrGateNoteTooLong", { maxLength: MAXDBLENGTHS.YARD_GATE_NOTE, gateNum: gateNum }));
              }
            }
          }
          return errors;
        }
      }]);

      return GatesField;
    }(BaseImportField);

    var EntryLatLonField = function (_BaseImportField18) {
      _inherits(EntryLatLonField, _BaseImportField18);

      function EntryLatLonField() {
        _classCallCheck(this, EntryLatLonField);

        return _possibleConstructorReturn(this, (EntryLatLonField.__proto__ || Object.getPrototypeOf(EntryLatLonField)).call(this, {
          name: "EntryLatLon",
          translationId: "templates.importPlaces.entryLatLonField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(EntryLatLonField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return EntryLatLonField;
    }(BaseImportField);

    var EntryLatLonSnapField = function (_BaseImportField19) {
      _inherits(EntryLatLonSnapField, _BaseImportField19);

      function EntryLatLonSnapField() {
        _classCallCheck(this, EntryLatLonSnapField);

        return _possibleConstructorReturn(this, (EntryLatLonSnapField.__proto__ || Object.getPrototypeOf(EntryLatLonSnapField)).call(this, {
          name: "EntryLatLonSnap",
          translationId: "templates.importPlaces.entryLatLonSnapField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(EntryLatLonSnapField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return EntryLatLonSnapField;
    }(BaseImportField);

    var EntryNotesField = function (_BaseImportField20) {
      _inherits(EntryNotesField, _BaseImportField20);

      function EntryNotesField() {
        _classCallCheck(this, EntryNotesField);

        return _possibleConstructorReturn(this, (EntryNotesField.__proto__ || Object.getPrototypeOf(EntryNotesField)).call(this, {
          name: "EntryNotes",
          translationId: "templates.importPlaces.entryNotesField",
          maxLength: MAXDBLENGTHS.YARD_GATE_NOTE,
          dependencies: [YardPointsField]
        }));
      }

      return EntryNotesField;
    }(BaseImportField);

    var ExitLatLonField = function (_BaseImportField21) {
      _inherits(ExitLatLonField, _BaseImportField21);

      function ExitLatLonField() {
        _classCallCheck(this, ExitLatLonField);

        return _possibleConstructorReturn(this, (ExitLatLonField.__proto__ || Object.getPrototypeOf(ExitLatLonField)).call(this, {
          name: "ExitLatLon",
          translationId: "templates.importPlaces.exitLatLonField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(ExitLatLonField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return ExitLatLonField;
    }(BaseImportField);

    var ExitLatLonSnapField = function (_BaseImportField22) {
      _inherits(ExitLatLonSnapField, _BaseImportField22);

      function ExitLatLonSnapField() {
        _classCallCheck(this, ExitLatLonSnapField);

        return _possibleConstructorReturn(this, (ExitLatLonSnapField.__proto__ || Object.getPrototypeOf(ExitLatLonSnapField)).call(this, {
          name: "ExitLatLonSnap",
          translationId: "templates.importPlaces.exitLatLonSnapField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(ExitLatLonSnapField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return ExitLatLonSnapField;
    }(BaseImportField);

    var ExitNotesField = function (_BaseImportField23) {
      _inherits(ExitNotesField, _BaseImportField23);

      function ExitNotesField() {
        _classCallCheck(this, ExitNotesField);

        return _possibleConstructorReturn(this, (ExitNotesField.__proto__ || Object.getPrototypeOf(ExitNotesField)).call(this, {
          name: "ExitNotes",
          translationId: "templates.importPlaces.exitNotesField",
          maxLength: MAXDBLENGTHS.YARD_GATE_NOTE,
          dependencies: [YardPointsField]
        }));
      }

      return ExitNotesField;
    }(BaseImportField);

    var SiteDetailField = function (_BaseImportField24) {
      _inherits(SiteDetailField, _BaseImportField24);

      function SiteDetailField() {
        _classCallCheck(this, SiteDetailField);

        return _possibleConstructorReturn(this, (SiteDetailField.__proto__ || Object.getPrototypeOf(SiteDetailField)).call(this, {
          name: "SiteDetail",
          translationId: "templates.importPlaces.siteDetailField",
          maxLength: MAXDBLENGTHS.SITE_DETAIL
        }));
      }

      _createClass(SiteDetailField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return SiteDetailField;
    }(BaseImportField);

    ///////////////////////////////////////////
    //PCM WEB UI STOPS SPECIFIC IMPORT FIELDS//
    ///////////////////////////////////////////

    var StopNameField = function (_BaseImportField25) {
      _inherits(StopNameField, _BaseImportField25);

      function StopNameField() {
        _classCallCheck(this, StopNameField);

        return _possibleConstructorReturn(this, (StopNameField.__proto__ || Object.getPrototypeOf(StopNameField)).call(this, {
          name: "StopName",
          translationId: "templates.importStops.stopNameField",
          maxLength: 100
        }));
      }

      _createClass(StopNameField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(StopNameField.prototype.__proto__ || Object.getPrototypeOf(StopNameField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("name");
        }
      }]);

      return StopNameField;
    }(BaseImportField);

    var EstimatedDurationField = function (_BaseImportField26) {
      _inherits(EstimatedDurationField, _BaseImportField26);

      function EstimatedDurationField() {
        _classCallCheck(this, EstimatedDurationField);

        return _possibleConstructorReturn(this, (EstimatedDurationField.__proto__ || Object.getPrototypeOf(EstimatedDurationField)).call(this, {
          name: "EstimatedDuration",
          translationId: "templates.importStops.estimatedDurationField",
          maxLength: 100
        }));
      }

      _createClass(EstimatedDurationField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(EstimatedDurationField.prototype.__proto__ || Object.getPrototypeOf(EstimatedDurationField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("duration");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var stopService = $injector.get("stopService");
          if (!fieldValue) {
            return [];
          }
          if (stopService.getHoursFromString(fieldValue) === null) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidDuration") + ")"];
          }
          return [];
        }
      }]);

      return EstimatedDurationField;
    }(BaseImportField);

    var EarliestArrivalTimeField = function (_BaseImportField27) {
      _inherits(EarliestArrivalTimeField, _BaseImportField27);

      function EarliestArrivalTimeField() {
        _classCallCheck(this, EarliestArrivalTimeField);

        return _possibleConstructorReturn(this, (EarliestArrivalTimeField.__proto__ || Object.getPrototypeOf(EarliestArrivalTimeField)).call(this, {
          name: "EarliestArrivalTime",
          translationId: "templates.importStops.earliestArrivalTimeField",
          maxLength: 100
        }));
      }

      _createClass(EarliestArrivalTimeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(EarliestArrivalTimeField.prototype.__proto__ || Object.getPrototypeOf(EarliestArrivalTimeField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("earliest");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!moment(fieldValue, "HH:mm").isValid()) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidEarliestArrivalTime") + ")"];
          }
          return [];
        }
      }]);

      return EarliestArrivalTimeField;
    }(BaseImportField);

    var LatestArrivalTimeField = function (_BaseImportField28) {
      _inherits(LatestArrivalTimeField, _BaseImportField28);

      function LatestArrivalTimeField() {
        _classCallCheck(this, LatestArrivalTimeField);

        return _possibleConstructorReturn(this, (LatestArrivalTimeField.__proto__ || Object.getPrototypeOf(LatestArrivalTimeField)).call(this, {
          name: "LatestArrivalTime",
          translationId: "templates.importStops.latestArrivalTimeField",
          maxLength: 100
        }));
      }

      _createClass(LatestArrivalTimeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(LatestArrivalTimeField.prototype.__proto__ || Object.getPrototypeOf(LatestArrivalTimeField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("latest");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!moment(fieldValue, "HH:mm").isValid()) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidLatestArrivalTime") + ")"];
          }
          return [];
        }
      }]);

      return LatestArrivalTimeField;
    }(BaseImportField);

    ////////////////////
    //HELPER FUNCTIONS//
    ////////////////////

    //If FileReader is undefined, the import CSV feature won't work


    function browserImportIncompatible() {
      var oldBrowser = false;
      try {
        var fileReaderTest = FileReader;
      } catch (err) {
        oldBrowser = true;
      }
      return oldBrowser;
    }

    function createGateError(fieldParams, translateKey, gateParams) {
      var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
      var gateErr = $translate.instant(translateKey, gateParams);
      return fieldErr + " (" + gateErr + ")";
    }

    function filterErrors(errs) {
      //Hide rest of errors if over 100 AND 50 more will be hidden
      if (errs.length > 100) {
        var hiddenErrCount = errs.length - 100;
        if (hiddenErrCount >= 50) {
          errs = errs.slice(0, 100);
          errs.push($translate.instant("common.import.tooManyErrors", { num: hiddenErrCount }));
        }
      }
      return errs;
    }

    function testCompanyIds(cidList) {
      return placeCloudService.testCompanyIds(cidList);
    }

    function importPlaces(places, importType) {
      var wizardData = alkModalService.getCurrentWizardData();
      var setName = wizardData.setName;
      var setId = wizardData.selectedSet ? wizardData.selectedSet.Id : "";
      var category = wizardData.selectedCategory; // should only be used if importing New Set
      return placeCloudService.getCategoryForSet(wizardData.selectedSet).then(function (catId) {
        if (wizardData.selectedSet && wizardData.selectedSet.Categories && wizardData.selectedSet.Categories[0]) {
          catId = wizardData.selectedSet.Categories[0].Id;
        }
        var setOptions = wizardData.copilotOptions;

        places = _.map(places, function (row) {
          var place = {};
          place.placeName = row.PlaceName;
          place.companyId = row.CompanyId;
          place.latitude = row.Latitude;
          place.longitude = row.Longitude;
          place.street = row.StreetAddress;
          place.city = row.City;
          place.state = row.State;
          place.zip = row.Zip;
          place.country = row.Country;
          place.phone = row.Phone;
          place.info = row.Comments;
          place.yardName = row.YardName;
          place.yardPoints = getYardPointsFromString(row.YardPoints);
          place.gates = getGatesFromString(row.Gates);

          var entryLatLon = getLatLonFromString(row.EntryLatLon);
          var entryLatLonSnap = getLatLonFromString(row.EntryLatLonSnap);
          var entryNotes = row.EntryNotes;
          if (entryLatLon && entryLatLonSnap) {
            var entryGate = {
              Coords: entryLatLon,
              SnapCoords: entryLatLonSnap,
              Type: 0,
              AutoRestricted: false,
              TruckRestricted: false,
              NoteContent: entryNotes
            };
            place.gates.push(entryGate);
          }

          var exitLatLon = getLatLonFromString(row.ExitLatLon);
          var exitLatLonSnap = getLatLonFromString(row.ExitLatLonSnap);
          var exitNotes = row.ExitNotes;
          if (exitLatLon && exitLatLonSnap) {
            var exitGate = {
              Coords: exitLatLon,
              SnapCoords: exitLatLonSnap,
              Type: 1,
              AutoRestricted: false,
              TruckRestricted: false,
              NoteContent: exitNotes
            };
            place.gates.push(exitGate);
          }

          // don't need to send "" to database
          if (row.SiteDetail) {
            place.siteDetail = row.SiteDetail;
          }

          return place;
        });

        return setPLIDsForPlaces(places).then(function () {
          var deferred = $q.defer();
          var promise;
          if (importType === 0) {
            promise = importPlacesNewSet(setName, places, setOptions, category);
          } else if (importType === 1) {
            promise = importPlacesAppend(setId, catId, places);
          } else if (importType === 2) {
            promise = importPlacesReplace(setId, catId, places);
          }
          promise.then(function (result) {
            if (!result) {
              deferred.reject($translate.instant("common.import.unknownError"));
            } else {
              deferred.resolve(result);
            }
          });
          return deferred.promise;
        });
      });
    }

    //Return array of plid promises for each this place's gates
    function setClosestPLIDToLonLat(place) {
      var linkWebService = $injector.get("linkWebService");
      var promises = [];

      var _loop = function _loop(gate) {
        var lon = gate.SnapCoords.Lon;
        var lat = gate.SnapCoords.Lat;
        var deferred = $q.defer();
        var left = lon;
        var bottom = lat;
        var right = lon;
        var top = lat;
        var bounds = new ALKMaps.Bounds(Number(left) - 0.001, Number(bottom) + 0.001, Number(right) + 0.001, Number(top) - 0.001);
        var mapDataVersion = UserProvider.getUser().dataVersion || "Current";
        var promise = linkWebService.getLinks(bounds.toBBOX(), mapDataVersion).then(function (results) {
          //console.log(results.data.features);
          var plid = "";
          var min = Number.POSITIVE_INFINITY;
          var minResult = null;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = results.data.features[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var result = _step2.value;

              var points = _.map(result.geometry.coordinates, function (coord) {
                return new ALKMaps.Geometry.Point(coord[0], coord[1]);
              });
              var linkGeom = new ALKMaps.Geometry.LineString(points);
              var dist = linkGeom.distanceTo(new ALKMaps.Geometry.Point(lon, lat));
              if (dist < min) {
                min = dist;
                minResult = result;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (minResult && minResult.properties.plid) {
            plid = minResult.properties.plid;
          }
          gate.plid = plid;
        });
        promises.push(promise);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = place.gates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var gate = _step.value;

          _loop(gate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return promises;
    }

    //Need to get PLID from snap coords before importing
    function setPLIDsForPlaces(places) {
      var deferred = $q.defer();
      var plidPromises = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = places[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var place = _step3.value;

          plidPromises = plidPromises.concat(setClosestPLIDToLonLat(place));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      $q.all(plidPromises).then(function () {
        deferred.resolve();
      });
      return deferred.promise;
    }

    //Helper function used by the import functions below that create the places and yards
    function importPlacesAndYardsHelper(setId, catId, places) {
      var deferred = $q.defer();
      var placesWithoutYards = _.remove(places, function (place) {
        return !place.yardPoints; //No points, no yard. Must have points for any of the other yard fields to make sense
      });
      var placeIds, yardIds;

      _.each(places, function (place, index) {
        //If the place doesn't have a yard name, give it one
        if (!place.yardName) {
          place.yardName = $translate.instant("templates.yards.unnamedYard");
        }
      });

      //Add the places without yards (this is batched for performance)
      placeCloudService.saveNewPlaces(setId, catId, placesWithoutYards).then(function (response) {
        if (!response) {
          deferred.resolve(null);
          return;
        }
        //If there are no places with yards, just quit here
        if (places.length === 0) {
          deferred.resolve({
            setId: setId
          });
          return;
        }
        //Add the places with yards
        addPlaceYardRecursiveHelper(0, catId);
      });

      return deferred.promise;

      //Initiates the callback chain for adding a single place and its yard data.
      function addPlaceYardRecursiveHelper(index, catId) {
        if (index >= places.length) {
          deferred.resolve({
            setId: setId
          });
          return;
        }
        var place = places[index];
        var yardId;
        //Add place
        placeCloudService.saveNewPlace(setId, catId, place).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          place.Id = response.Id;
          //Add yard
          return placeCloudService.addYard({
            yardName: place.yardName,
            shapePoints: place.yardPoints,
            siteDetail: place.siteDetail
          });
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          yardId = response.Id;
          //Add place to yard
          return placeCloudService.addPlaceToYard(yardId, place.Id, true);
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          //Add all yard gates
          return placeCloudService.addYardGates(yardId, place.gates).then(function (gatesRes) {
            //Any one failed: return failed
            if (gatesRes.indexOf(null) > -1) {
              deferred.resolve(null);
              return;
            }
            return response;
          });
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          addPlaceYardRecursiveHelper(index + 1, catId);
        });
      }
    }

    function importPlacesNewSet(setName, places, options, category) {
      var deferred = $q.defer();
      var setId = "";
      var setStyle = category;
      //Add the place set
      placeCloudService.addPlaceSet(setName, null, true, options, setStyle).then(function (response) {
        if (!response) {
          deferred.resolve(null);
          return;
        }
        setId = response.Id;
        placeCloudService.addCategoryForSet(setName, setId, options, category.Icon).then(function (catResponse) {
          importPlacesAndYardsHelper(setId, catResponse.Id, places).then(function (placesResponse) {
            if (!placesResponse)
              // pchen: if failed, manually rollback places creation
              placeCloudService.deletePlaceSet(setId);
            deferred.resolve(placesResponse);
          });
        });
      });

      return deferred.promise;
    }

    function importPlacesAppend(setId, catId, places) {
      var deferred = $q.defer();
      //Add the places
      importPlacesAndYardsHelper(setId, catId, places).then(function (response) {
        deferred.resolve(response);
      });
      return deferred.promise;
    }

    function importPlacesReplace(setId, catId, places) {
      var deferred = $q.defer();
      //Get the places in the set
      placeCloudService.getPlaces(setId).then(function (getResponse) {
        if (!getResponse) {
          deferred.resolve(null);
          return;
        }
        var placeIdList = [];
        _.each(getResponse.Places, function (place) {
          placeIdList.push(place.Id);
        });
        return placeCloudService.deletePlaces(placeIdList);
        //Delete the places in the set
      }).then(function (deleteResponse) {
        if (!deleteResponse) {
          deferred.resolve(null);
          return;
        }
        importPlacesAndYardsHelper(setId, catId, places).then(function (importResponse) {
          deferred.resolve(importResponse);
        });
      });
      return deferred.promise;
    }

    //"file" is js file input variable (i.e. files[0])
    function importExceptions(file, setId, setName, replace) {
      var deferred = $q.defer();
      /*deferred.resolve();
      return deferred.promise;
      */
      var reader = new FileReader();
      reader.onload = function () {
        var base64EncodedString = reader.result;
        base64EncodedString = base64EncodedString.split(",")[1];
        var b = atob(base64EncodedString);
        var byteNumbers = new Array(b.length);
        for (var i = 0; i < b.length; i++) {
          byteNumbers[i] = b.charCodeAt(i);
        }
        var request = {
          method: "POST",
          url: config.pcmwsUrl + "AvoidFavorSets/import",
          headers: {
            Authorization: config.alkmapsApiKey
          },
          params: {
            dataset: UserProvider.getUser().dataset || UserProvider.getUser().dataVersion || "Current"
          },
          data: {
            SetName: !setId ? setName : "",
            SetTag: null,
            SetID: !setId ? -1 : setId,
            FileBytes: byteNumbers,
            Replace: !replace ? false : replace
          }
        };
        $http(request).then(function (response) {
          //success
          deferred.resolve(response.data);
        }, function (response) {
          //fail
          deferred.reject(response);
        });
      };
      reader.onerror = function (err) {
        deferred.reject(err);
      };
      reader.readAsDataURL(file);
      return deferred.promise;
    }

    function isLatLonStringValid(latLonString) {
      if (!latLonString) {
        return true; //Can be blank
      }
      var coords = getLatLonFromString(latLonString);
      if (!coords) {
        return false;
      }
      // fail on null lat/lon
      if (coords.Lat === 0 && coords.Lon === 0) {
        return false;
      }
      return true;
    }

    function getLatLonFromString(str) {
      if (!str) {
        return null;
      }
      var pieces = str.split(",");
      if (pieces.length < 2) {
        return null;
      }
      if (!isLatValid(pieces[0]) || !isLonValid(pieces[1])) {
        return null;
      }
      return {
        Lat: Number(pieces[0]),
        Lon: Number(pieces[1])
      };
    }

    function allLatLonValid(coordStrs) {
      return coordStrs.every(function (coordStr) {
        var latLonSplit = coordStr.split(",");
        //Each coord must have a lat and lon
        if (latLonSplit.length < 2) {
          return false;
        }
        var lat = Number(latLonSplit[0]);
        var lon = Number(latLonSplit[1]);
        //They must be valid lat/lons
        if (!isLatValid(lat) || !isLonValid(lon)) {
          return false;
        }
        return true;
      });
    }

    function isLatLonValid(fieldValue, maxBound) {
      if (isNaN(fieldValue) || Number(fieldValue) < -maxBound || Number(fieldValue) > maxBound) {
        return false;
      }
      return true;
    }

    function isLatValid(fieldValue) {
      return isLatLonValid(fieldValue, 90);
    }

    function isLonValid(fieldValue) {
      return isLatLonValid(fieldValue, 180);
    }

    function getYardPointsFromString(importStr) {
      if (!importStr) {
        return null;
      }
      var points = [];
      _.each(importStr.split("|"), function (coordStr) {
        var lat = Number(coordStr.split(",")[0]);
        var lon = Number(coordStr.split(",")[1]);
        points.push([lon, lat]);
      });
      return points;
    }

    function getGatesFromString(importStr) {
      if (!importStr) {
        return [];
      }
      var gatesField = new GatesField();
      if (gatesField.getErrors(importStr, {}).length > 0) {
        return [];
      }

      var escPipeChar = String.fromCharCode(13);
      var escCaretChar = String.fromCharCode(14);
      var escBackslashChar = String.fromCharCode(15);

      //Gates is double delimited by ^ for gates and | for the gate fields.
      //So the import string must escape '^', '|' and '\' chars by prefacing with a '\' char.
      importStr = getDecodedImportString(importStr, escPipeChar, escCaretChar, escBackslashChar);

      var gates = [];
      var gateStrs = importStr.split("^");
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = gateStrs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var gateStr = _step4.value;

          var pieces = gateStr.split("|");
          var gate = {
            Coords: {
              Lat: pieces[0].split(",")[0],
              Lon: pieces[0].split(",")[1]
            },
            SnapCoords: {
              Lat: pieces[1].split(",")[0],
              Lon: pieces[1].split(",")[1]
            },
            Type: Number(pieces[2]),
            AutoRestricted: pieces[3] === "1" ? true : false,
            TruckRestricted: pieces[4] === "1" ? true : false,
            NoteContent: pieces[5].replace(new RegExp(escPipeChar, "g"), "|").replace(new RegExp(escCaretChar, "g"), "^").replace(new RegExp(escBackslashChar, "g"), "\\")
          };
          gates.push(gate);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return gates;
    }

    //Encode the note by escaping '^', '|' and '\' chars by prefacing with a '\' char.
    function getEncodedNote(noteString) {
      noteString = noteString.replace(/\\/g, "\\\\");
      noteString = noteString.replace(/\|/g, "\\\|");
      noteString = noteString.replace(/\^/g, "\\\^");
      return noteString;
    }

    //Reads importStr from left to right.
    //Upon encountering \\, replaces with escBackslashChar.
    //Upon encountering \|, replaces with escPipeChar.
    //Upon encountering \^, replaces with escCaretChar.
    function getDecodedImportString(importStr, escPipeChar, escCaretChar, escBackslashChar) {
      var c16 = String.fromCharCode(16);

      var importStrArray = importStr.split("");
      for (var i = 0; i < importStr.length - 1; i++) {
        var charPair = importStr.substring(i, i + 2);
        if (charPair === "\\\\") {
          importStrArray[i] = escBackslashChar;
          importStrArray[i + 1] = c16;
          i++;
        } else if (charPair === "\\|") {
          importStrArray[i] = escPipeChar;
          importStrArray[i + 1] = c16;
          i++;
        } else if (charPair === "\\^") {
          importStrArray[i] = escCaretChar;
          importStrArray[i + 1] = c16;
          i++;
        }
      }
      importStr = importStrArray.join("");
      importStr = importStr.replace(new RegExp(c16, "g"), "");
      return importStr;
    }

    function strContainsLonLat(importStr, lon, lat, threshold) {
      if (!importStr) {
        return true;
      }
      var coords = getYardPointsFromString(importStr);
      return containsLonLat(coords, lon, lat, threshold);
    }

    function validateNoInvalidChar(fieldValue, fieldParams) {
      if (!fieldValue) {
        return [];
      }
      if (!INVALID_CHAR_REGEX.test(fieldValue)) {
        return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.canNotContainSpecialCharacters") + "): " + fieldValue];
      }
      return [];
    }

    //Note: will return true for invalid (i.e. blank) paramters. Reason is because "place not in site" error should not show if lat/lon/importCoords are invalid
    function containsLonLat(importCoords, lon, lat, threshold) {
      var mapUtilities = $injector.get("mapUtilities");
      if (!importCoords || !lon || !lat) {
        return true;
      }
      var poly = [];
      var mercLL;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = importCoords[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var coords = _step5.value;

          mercLL = mapUtilities.LLtoMerc(coords[0], coords[1]);
          poly.push(new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat));
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var ring = new ALKMaps.Geometry.LinearRing(poly);
      mercLL = mapUtilities.LLtoMerc(lon, lat);
      var point = new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat);
      if (ring.containsPoint(point) && ring.distanceTo(point) !== 0) {
        return true;
      } else if (threshold) {
        var dist = ring.distanceTo(point);
        // only 8 digits of gate lat/lon are stored in db, causing uncertainty to be at least 1.2 units
        if (dist < 0.2) {
          return true;
        }
      }
      return false;
    }

    //address object format: obj.StreetAddress, obj.City, obj.State, obj.Zip
    function batchGeocodeAddresses(addresses, progressCallback) {
      var MAX_PER_BATCH = 100;
      var MIN_BATCHES = 6;

      var deferred = $q.defer();
      var results = [];
      var addressBatches = [];
      var counter = 0;

      //Split into MIN_BATCHES separate requests if over MIN_BATCHES addresses to geocode
      if (addresses.length < MIN_BATCHES) {
        addressBatches = [addresses];
      } else {
        //Increase the number of batches until the amount per batch is less than or equal to MAX_PER_BATCH.
        var num_batches = MIN_BATCHES - 1; //Start off at 1 less to account for first increment in do-while loop
        var num_in_batch;
        do {
          num_batches++;
          num_in_batch = Math.round(addresses.length / num_batches);
        } while (num_in_batch > MAX_PER_BATCH);
        //console.log("Splitting " + addresses.length + " entries into " + num_batches + " batches with " + num_in_batch + " entries each");

        //Split the addresses into "num_batches" batches
        addressBatches = chunkify(addresses, num_batches, true);
      }
      progressCallback(0, addressBatches.length);

      _.each(addressBatches, function (addressBatch) {
        counter++;
        var locations = [];
        _.each(addressBatch, function (address) {
          var location = {};
          //Address fields
          location.Address = address;

          //Location fields
          location.Region = PCMRegion[UserProvider.getUser().region];
          locations.push(location);
        });
        var request = {
          method: "POST",
          url: config.pcmwsUrl + "locations/address/batch",
          headers: {
            Authorization: config.alkmapsApiKey,
            BatchIndex: String(counter)
          },
          params: {
            dataset: UserProvider.getUser().dataset || UserProvider.getUser().dataVersion || "Current"
          },
          data: {
            Locations: locations
          }
        };
        return $http(request).then(function (response) {
          //success
          results.push(response);
          progressCallback(results.length, addressBatches.length);
          if (results.length === addressBatches.length) {
            //The responses may not come back in the order they were sent so sort them first
            results.sort(function (a, b) {
              return Number(a.config.headers.BatchIndex) - Number(b.config.headers.BatchIndex);
            });
            //Because we split up calls to the batch geocoder, assemble responses here
            var mergedResults = [];
            for (var j = 0; j < results.length; j++) {
              mergedResults = mergedResults.concat(results[j].data);
            }
            deferred.resolve(mergedResults);
          }
        }, function (response) {
          //fail
          results = null;
          deferred.resolve(null);
        });
      });

      return deferred.promise;
    }

    //Split array a into n arrays (set balanced = true for equal subarray length)
    function chunkify(a, n, balanced) {
      if (n < 2) {
        return [a];
      }
      var len = a.length,
          out = [],
          i = 0,
          size;
      if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
          out.push(a.slice(i, i += size));
        }
      } else if (balanced) {
        while (i < len) {
          size = Math.ceil((len - i) / n--);
          out.push(a.slice(i, i += size));
        }
      } else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) size--;
        while (i < size * n) {
          out.push(a.slice(i, i += size));
        }
        out.push(a.slice(size * n));
      }
      return out;
    }

    return {
      //Constants
      invalidCharRegex: INVALID_CHAR_REGEX,

      //Helper functions
      browserImportIncompatible: browserImportIncompatible,
      filterErrors: filterErrors,
      testCompanyIds: testCompanyIds,
      importPlaces: importPlaces,
      importExceptions: importExceptions,
      isLatLonStringValid: isLatLonStringValid,
      getLatLonFromString: getLatLonFromString,
      isLatLonValid: isLatLonValid,
      isLatValid: isLatValid,
      isLonValid: isLonValid,
      getYardPointsFromString: getYardPointsFromString,
      getGatesFromString: getGatesFromString,
      getEncodedNote: getEncodedNote,
      getDecodedImportString: getDecodedImportString,
      strContainsLonLat: strContainsLonLat,
      containsLonLat: containsLonLat,
      batchGeocodeAddresses: batchGeocodeAddresses,

      //Import fields (since they are ES6 classes must be instantiated first)
      LatitudeField: new LatitudeField(),
      LongitudeField: new LongitudeField(),
      LatLonField: new LatLonField(),
      StreetAddressField: new StreetAddressField(),
      CityField: new CityField(),
      StateField: new StateField(),
      CountryAbbrevField: new CountryAbbrevField(),
      ZipField: new ZipField(),
      CountyField: new CountyField(),
      CountryField: new CountryField(),
      PlaceNameField: new PlaceNameField(),
      CompanyIdField: new CompanyIdField(),
      PhoneField: new PhoneField(),
      CommentsField: new CommentsField(),
      YardNameField: new YardNameField(),
      YardPointsField: new YardPointsField(),
      GatesField: new GatesField(),
      EntryLatLonField: new EntryLatLonField(),
      EntryLatLonSnapField: new EntryLatLonSnapField(),
      EntryNotesField: new EntryNotesField(),
      ExitLatLonField: new ExitLatLonField(),
      ExitLatLonSnapField: new ExitLatLonSnapField(),
      ExitNotesField: new ExitNotesField(),
      SiteDetailField: new SiteDetailField(),
      StopNameField: new StopNameField(),
      EstimatedDurationField: new EstimatedDurationField(),
      EarliestArrivalTimeField: new EarliestArrivalTimeField(),
      LatestArrivalTimeField: new LatestArrivalTimeField()
    };
  }
})();


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/alkImport.service.js